import htmx from 'htmx.org'

import bindDutchAddressLookupListener from '../components/address-lookup.js'

htmx.onLoad((content) => {
  const form = content.querySelector('form[name="ps_campaign_boat"]')

  if (!(form instanceof HTMLFormElement)) {
    return
  }

  const addressContainer = form.querySelector('[data-address-lookup]')
  const api = form.dataset.addressLookupApiNl

  if (addressContainer && api) {
    bindDutchAddressLookupListener(addressContainer, api)
  }
})
